import React from "react";
import Grid from "@material-ui/core/Grid";
import styles from "./styles";
import LoginBanner from "../../../assets/login_banner-movil.png";
import FLogin from "../FLogin";
const VLogin = () => {
  const classes = styles();
  return (
    <Grid container>
      <Grid item xs={12} md={5}>
        <FLogin />
      </Grid>
      <Grid item xs={12} md={7}>
        <div className={classes.imagenBienvenida}>
          <img
            src={LoginBanner}
            className={classes.bienvenida}
            alt="BannerLogin"
          />
        </div>
      </Grid>
    </Grid>
  );
};
export default VLogin;
